'use client';
import React, { MouseEventHandler, useEffect, useState } from 'react';
import MaterialButton from "@/components/ui/buttons/global/MaterialButton";
import CircularProgressIndicator from "@/components/ui/main/CircularProgressIndicator";

export default ({url, onCloseModal}: {
  url: string,
  onCloseModal: MouseEventHandler<HTMLButtonElement>
}) => {
  const [isSSR, setIsSSR] = useState(true);

  useEffect(() => {
    setIsSSR(false);
  }, []);

  return (
    !isSSR ? (
      <div
        className="fixed inset-0 bg-stone-600 bg-opacity-50 z-50 overflow-y-auto h-full w-full flex items-center justify-center">
        <div
          className="p-2 w-full max-w-2xl bg-white border border-gray-200 rounded-2xl shadow sm:p-6 md:p-8 dark:bg-stone-800 dark:border-gray-700">

          <div className={'relative rounded-2xl overflow-hidden ring-1 shadow-xl ring-white dark:ring-gray-700'}>

            <video
              controls
              width={0}
              height={0}
              className="aspect-video max-h-96 object-cover "
              style={{ width: '100%', height: 'auto' }}
            >
              <source src={url}
                      type="video/mp4"
              />
            </video>

            <div className="absolute top-3 right-3">
              <MaterialButton text={'close'} onClick={onCloseModal} />
            </div>
          </div>


        </div>
      </div>


      // <div className="w-full aspect-video max-h-96 object-cover">
      //     <ReactPlayer
      //         controls
      //         style={{width: "100%", height: "auto"}}
      //         playing={false}
      //         url={[url]}
      //         fallback={<>loading</>}
      //     />
      // </div>
    ) : <CircularProgressIndicator />
  );
}
